<template>
  <label   :class="{ 'radio-custom-label': true, 'radio-custom-disabled' : $attrs.disabled}">
    <div class="radio-custom">
      <input
       :aria-label="`${arialabel} opção ${label}`"
        type="radio"
        :name="name"
        v-bind="$attrs"
        :checked="value == val"
        @change="$emit('input', val)"
        @click="clicar"
        :value="val" />
        <div class="radio-custom--radio"></div>
        <span style="margin-top: 2px">{{ label }}</span>
    </div>
  </label>
</template>

<script>
export default {
  name: 'Radio',
  props: {
    value: [String, Number],
    label: [String, Number],
    val: [String, Number],
    arialabel: [String],
    name: String,
  },
  methods: {
    clicar(event) {
      // event.target.blur();
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
$corPadrao: #01848c;

.radio-custom{
  display: flex;
  margin: 2px 10px 2px 0px;

  input{
    width: 0;
    height: 0;
    opacity:0;

    &:disabled{
      &~ .radio-custom--radio{
        border-color: #a0a0a0!important;
        &:after{
          background-color: #a0a0a0!important;
        }
      }
    }

    &:checked{
      &~ .radio-custom--radio{
        border: 2px solid $corPadrao;

        &:after{
          content: '';
        }
      }
    }

    &:focus {
      &~ .radio-custom--radio::before {
        content: '';
      }
    }
  }

  .radio-custom--radio{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #a0a0a0;
    content: '';
    display: block;
    margin: 2px 8px 0px 4px;

    &:after{
      display: block;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background-color: $corPadrao;
      transform: translateX(23%) translateY(23%);
      -moz-transform: translateX(23%) translateY(23%);
      -webkit-transform: translateX(23%) translateY(23%);
    }

    &:before {
      width: 28px;
      height: 28px;
      background-color: $corPadrao;
      display: block;
      opacity: .3;
      border-radius: 50%;
      transform: translateX(-21%) translateY(-21%);
      position: absolute;
      -moz-transform: translateX(-21%) translateY(-21%);
      -webkit-transform: translateX(-21%) translateY(-21%);
    }
  }
}

.radio-custom-label{
  cursor: pointer;
}

.radio-custom-disabled{
  cursor: default;
  .radio-custom-label{
    color: gray;
  }
}

@keyframes radiocheck{
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
</style>
